/*******************************************************************************
 * Copyright     : Copyright (c)  2020 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc., and its use or disclosure in whole or in
 *                 part without express written permission of Honeywell Inc.
 *                 is prohibited.
 *
 * Name          : GeneralInfo.tsx
 *
 * Project Title : APM Settings Tool
 *
 * Description   : General Info main component
 *
 *
 * Company       : Honeywell Technology Solutions , Hyderabad
 *
 * @Author       : H422337
 *
 * @Date         : Dec 30,2021
 *
 * @Version      : Version 1.0
 *
 * By            :
 * On            :
 * Description   :
 *
 *
 ******************************************************************************/

import React, { FC } from "react";
import { APMSettingsForm } from "./APMSettingsForm";
import { selectSelectedApmRecordLoader } from "stores/ApmWorkFlowStore";
import { useSelector } from "react-redux";
import { CommonLoader } from "components/CommonLoader";
import { selectSaveDetailsLoading } from "stores/ApmSettingsStore";
import "./APMSettings.scss";

export const APMSettings: FC = () => {
  const currentApmFileRecordLoader = useSelector(selectSelectedApmRecordLoader);
  const saveAPMDetailsLoader = useSelector(selectSaveDetailsLoading);

  return (
    <>
      <div className="apm-wrapper">
        {currentApmFileRecordLoader || saveAPMDetailsLoader ? (
          <CommonLoader />
        ) : (
          <APMSettingsForm />
        )}
      </div>
    </>
  );
};
